const bannerLoading = () => {
  const banner = $('.home-banner');

  setTimeout(() => {
    banner.addClass('loaded');
  }, 500);
};

export default bannerLoading;
